import pRetry from "p-retry";
import { TraceEventDetailsV2 } from "./graphql/queries";

const RunV2 = async (
    client,
    traceItem: string,
    orgId: string,
    eventId?: string,
    traceDirection?: string
  ) => {
      const { data } = await client.query({
          query: TraceEventDetailsV2,
          variables: {
              filters: {
                  traceItemId: traceItem,
                  orgId: orgId,
                  isAuth: false,
                  ...(eventId ? { eventId } : {}),
                  ...(traceDirection ? { traceDirection } : {})
              }
          },
          fetchPolicy: "network-only",
      });
      return data;
  };

const fetchRetryV2 = async (
    client,
    traceItem: string,
    orgId: string,
    eventId?: string,
    traceDirection?: string
  ) => {
      return await pRetry(() => RunV2(client, traceItem, orgId, eventId, traceDirection), {
          retries: 5,
          onFailedAttempt: error => {
              console.log(`V2 Attempt ${error.attemptNumber} failed. There are ${error.retriesLeft} retries left.`);
          },
      });
  };

export const traceEventDetailsV2 = async (
    params: { traceItem: string, orgId: string, eventId?: string, traceDirection?: string, client }
  ) => {
      const { traceItem, orgId, eventId, traceDirection, client } = params;
      return await fetchRetryV2(client, traceItem, orgId, eventId, traceDirection);
  };
